import { render } from "./comptoir.vue?vue&type=template&id=6be8dacb&scoped=true"
import script from "./comptoir.vue?vue&type=script&lang=js"
export * from "./comptoir.vue?vue&type=script&lang=js"

import "./comptoir.vue?vue&type=style&index=0&id=6be8dacb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be8dacb"]])

export default __exports__